var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_ios_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/arrow_forward_ios_24px",
    d: "M2.48751 5.83184C2.07918 6.24017 2.07918 6.8985 2.48751 7.30684L9.41251 14.2318C9.73751 14.5568 10.2625 14.5568 10.5875 14.2318L17.5125 7.30684C17.9208 6.8985 17.9208 6.24017 17.5125 5.83184C17.1042 5.4235 16.4458 5.4235 16.0375 5.83184L9.99585 11.8652L3.95418 5.8235C3.55418 5.4235 2.88751 5.4235 2.48751 5.83184Z",
    fill: "#808080"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevArrow);
export default __webpack_public_path__ + "static/media/chev_arrow.f1dc8e2c.svg";
export { ForwardRef as ReactComponent };